module.exports = __webpack_public_path__ + "static/media/jc.4382e99b.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/hd202112/jc.png
// module id = 352
// module chunks = 0